$( document ).ready(function() {
    var elem = $('.price-table--engine').parent().closest('div');
    elem.removeClass('col__l-1-of-3').addClass('col__l-1-of-2');
});
